import { cx, Link, Note } from '@elsa/ui';
import type { ReactNode } from 'react';
import { useOrg } from '../lib/session.tsx';

// Ce e in afara abonamentului (codurile CPV pe care firma nu le are, docs/23 §4.1): lacatul,
// textul estompat si nota cu ce poate face firma. Datele produselor blocate nu ajung deloc
// in browser; textul estompat e un inlocuitor, nu continutul real.

export function LockIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 16 16"
      aria-hidden="true"
      fill="currentColor"
      className={cx('inline-block h-3.5 w-3.5 shrink-0', className)}
    >
      <path d="M8 1a3.5 3.5 0 0 0-3.5 3.5V7H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-.5V4.5A3.5 3.5 0 0 0 8 1Zm2 6H6V4.5a2 2 0 1 1 4 0V7Z" />
    </svg>
  );
}

/** Un inlocuitor estompat (ascuns cititoarelor de ecran), in locul unei valori blocate. */
export function Blurred({ children }: { children: ReactNode }) {
  return (
    <span aria-hidden="true" className="select-none blur-[3px] text-gri-700">
      {children}
    </span>
  );
}

/** Eticheta „în afara abonamentului”, langa un cod CPV. */
export function OutsidePlan({ label = 'în afara abonamentului' }: { label?: string }) {
  return (
    <span className="inline-flex items-center gap-1 whitespace-nowrap bg-gri-200 px-1.5 py-0.5 text-[11px] font-bold leading-4 text-gri-800">
      <LockIcon className="h-3 w-3" />
      {label}
    </span>
  );
}

/** Ce poate face firma ca sa vada un cod: Setari firma (codurile) sau Abonament (pachetul). */
export function AddCodesHint() {
  const { can } = useOrg();
  if (can('settings.manage')) {
    return (
      <>
        Codurile se adaugă din{' '}
        <Link to="/app/setari" className="font-medium underline">
          Setări firmă
        </Link>
        {can('billing.manage') ? (
          <>
            {' '}
            sau, dacă pachetul e plin, din{' '}
            <Link to="/app/abonament" className="font-medium underline">
              Abonament
            </Link>
          </>
        ) : null}
        .
      </>
    );
  }
  return <>Proprietarul firmei poate adăuga codurile din Setări firmă.</>;
}

/** Nota de deasupra produselor blocate ale unei achizitii. */
export function LockedNote({ count, codes }: { count: number; codes: string[] }) {
  return (
    <Note>
      <span className="inline-flex items-start gap-1.5">
        <LockIcon className="mt-0.5" />
        <span>
          {count === 1 ? 'Un produs' : `${count} produse`} din această achiziție{' '}
          {count === 1 ? 'e' : 'sunt'} pe {codes.length === 1 ? 'codul' : 'codurile'} CPV{' '}
          <b>{codes.join(', ')}</b>, care nu {codes.length === 1 ? 'e' : 'sunt'} în abonamentul
          firmei: denumirea, cantitatea și prețul nu se văd. <AddCodesHint />
        </span>
      </span>
    </Note>
  );
}
